// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__3Ak9J","expandIcon":"AccordionButton_expandIcon__VM6Nq","expanded":"AccordionButton_expanded__30uWH"};